import { Component, input, ViewEncapsulation } from '@angular/core';
import { bindModifierGroup, provideBaseClass } from '@bynary/composables/class';

import { SpinnerSize } from './models/spinner-size';

/**
 * Spinner component for indicating a loading action takes place
 */
@Component({
    selector: 'sona-spinner',
    imports: [],
    templateUrl: './spinner.component.html',
    styleUrls: ['./spinner.component.scss'],
    encapsulation: ViewEncapsulation.None,
    providers: [provideBaseClass('c-sona-spinner')],
    host: {
        class: 'spinner-border',
        'attr.role': 'status'
    }
})
export class SonaSpinnerComponent {

    /**
     * The size of the spinner
     */
    readonly size = input<SpinnerSize>('md');

    constructor() {
        bindModifierGroup(this.size, { prefix: 'size' });
    }
}
